import React from "react";
import terms_and_conditions_image from "../../assets/image/png/terms-and-conditions_image.png";

const PrivacyPolicyHero = () => {
  return (
    <div className="pb-4 bg-white">
      <div className="position-relative">
        <img
          height={300}
          className="w-100 obj-fit" 
          src={terms_and_conditions_image}
          alt="terms_and_conditions_image"
        />
        <div className="position-absolute w-100 text-center  tranform_m1">
          <h4 className=" fs_48 ff_raleway fw-bold text-white">
            Privacy Policy
          </h4>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyHero;
